import React, { useContext, useState, useEffect } from 'react'
import { userContext } from "../../../../context/userContext";
import { useTranslation } from "react-i18next";
import { environmentVariables } from "../../../../config/env.config.js";
import './tabOrder.css';
import myorder62 from "../../../../Images/Restaurant/myorder62.png";
import prevVector from "../../../../Images/Restaurant/prevVector.svg";
import download62 from "../../../../Images/Restaurant/download62.png";

const TabAddOn = ({ orderItems, removeItem, updateTotalAmount, setOrderItems, rs, colordata, handleAddToOrder, menuItem, handleAddOnPay,setAddOn}) => {
  const { userData } = useContext(userContext);
  const { t } = useTranslation();
  const [currencySymbol, setCurrencySymbol] = useState('₹');
 
  const [selectedAddon, setSelectedAddon] = useState(menuItem?.quantity?.[0] || ""); // Track the selected addon
      const [selectedPrice, setSelectedPrice] = useState(menuItem?.price?.[0] || 0);
      const [selecteditemsize,setSelectedItemSize]=useState(menuItem?.quantity?.[0] || "");
  const handleAddonChange = (addon,price,itemSize) => {
     setSelectedAddon(addon);
     setSelectedPrice(price);
     setSelectedItemSize(itemSize);
};

  return (
  <div style={{position:"absolute",height:"100vh",inset:"0",background:"transparent"}} onClick={()=>setAddOn(false)}>
    <div id="tabAddOn62" style={{background:colordata?.dynamicBackgroundColor || ""}} onClick={(e) => e.stopPropagation()}>
        <div className='itemName62' style={{position:"relative"}}>
              <img style={{width:'68px',height:'68px',borderRadius:'10px'}}  src={
                                        menuItem?.image === ""
                                                    ? `${environmentVariables.apiUrl}uploads/No image available.png`
                                                    : menuItem?.image.includes('/')
                                                        ? `https://businessbay.b-cdn.net${menuItem?.image}`
                                                        : `${environmentVariables.s3UrlBackendUrl}${menuItem?.image}`
                                            } ></img>

            <h2 style={{color:colordata?.dynamicTextHeadingColor || ""}}>{menuItem?.name}</h2>
            <span className='addonCross' style={{color:colordata?.dynamicCtaTextColor || ""}}  onClick={()=>setAddOn(false)}>+</span>
        </div>

        <div className="addonOptions62">
    {menuItem?.quantity?.map((addon, index) => (
    <label className="addonOption62" style={{color:colordata?.dynamicTextHeadingColor || ""}} key={index}>
        <span>{addon}</span>
        <p className="addonOption62" style={{color:colordata?.dynamicTextHeadingColor || ""}}>
        {/* <p> */}
            {t("Price")}: {currencySymbol}{(parseFloat(menuItem?.price?.[index]) || 0).toFixed(2) || ""} 
            
             <input
                type="radio" 
                name="addonSelection"  // Unique name for each to allow multiple selections
                value={addon}
                checked={selectedAddon === addon}
                onChange={() => handleAddonChange(addon,menuItem?.price?.[index],menuItem?.quantity?.[index])}
            />
        </p>
    </label>
))}

</div>
        <div style={{display:"flex",justifyContent:"center", paddingTop:"1rem", borderTop:"1px solid #292929" }}>
            <button className="payButton62" 
            // onClick={()=> handleAddToOrder()}
            style={{background:colordata?.dynamicCtaColor || "",color:colordata?.dynamicCtaTextColor || ""}}
            onClick={() => handleAddOnPay(menuItem,selectedPrice,selecteditemsize)}
            > 
            {t("Add")}
            {/* PAY ₹{selectedPrice} */}
            </button>
        </div>
     </div>
    </div>
  )
}

export default TabAddOn